import { Endpoint } from '../endpoint';
import { R } from '@core/utils/r';
import { ARBusinessViewResponse, ARVizpadResponse, ARDashboardResponse } from '@business/entities/advancedReporting';

export function fetchAccessKey() {
  return Endpoint.get<{ accessKey: string }>(`@gc/advanced-reporting/access-key`);
}

export function fetchBusinessViews() {
  return Endpoint.get<ARBusinessViewResponse[]>(`@gc/advanced-reporting/business-views`);
}

export function fetchVizpads() {
  return Endpoint.get<ARVizpadResponse[]>(`@gc/advanced-reporting/vizpads`);
}

export function fetchDashoards() {
  return Endpoint.get<ARDashboardResponse[]>(`@gc/advanced-reporting`);
}

export function fetchDashboard(id: string) {
  return Endpoint.get<ARDashboardResponse>(`@gc/advanced-reporting/dashboard/${id}`);
}

export function createDashboard(data: Partial<ARDashboardResponse>) {
  return Endpoint.post<ARDashboardResponse>(`@gc/advanced-reporting`, { data });
}

export function updateDashboard(id: string, data: Partial<ARDashboardResponse>) {
  return Endpoint.patch<ARDashboardResponse>(`@gc/advanced-reporting/${id}`, { data });
}

export function deleteDashboard(id: string) {
  return Endpoint.delete<void>(`@gc/advanced-reporting/${id}`);
}

export function copyDashboard(id: string) {
  return Endpoint.post<ARDashboardResponse>(`@gc/advanced-reporting/copy/${id}`);
}
